<template>
  <v-container fill-height fluid grid-list-xl>
    <v-dialog v-model="showDialog" :width="$vuetify.breakpoint.smAndDown ? '95%' : '50%'" persistent>
      <v-card class="pa-2">
        <!-- Título -->
        <v-card-title>
          {{titulo}}
        </v-card-title>
        <v-card-text>
          <br>
          <h2 style="word-break: break-word;">{{texto}}</h2>
        </v-card-text>
        <br>
        <v-card-actions class="d-flex justify-space-between flex-wrap">
          <template v-if="!hidebuttons">
            <v-btn
              class="mb-2"
              style="min-height: 44px; flex-grow: 1; margin: 0 4px;"
              @click="$emit('confirmar')"
              ><strong>Confirmar</strong>
              <v-icon color="green" right>mdi-check</v-icon>
            </v-btn>
            <v-btn
              class="mb-2"
              style="min-height: 44px; flex-grow: 1; margin: 0 4px;"
              @click="$emit('cancelar')"
              ><strong>Cancelar</strong>
              <v-icon color="red" right>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  props: ['show','titulo','texto','hidebuttons'],
  data: () => ({
    showDialog: false
  }),
  watch: {
    show(val) {
      this.showDialog = val
    }
  }
};
</script>
